export enum AppSettings {
  HEADER_LIBS = 'etisalat-headlibs/master.head.html',
  FOOTER_LIBS = 'etisalat-footerlibs/master.footerlibs.html',

  APPLICATION_HEADER_URL = '/system/wst/wst-top-nav-cons/master.body.html',
  APPLICATION_NAVIATION_URL = '/system/wst/wst-main-navigation/master.body.html',
  APPLICATION_FOOTER_URL = '/consumer-revamp/revamp-footer-links/master.html',
  APPLICATION_QLINKS_FOOTER_URL = '', // empty to stop shiwing duplicate footers
  POSTPAID_POSTER_URL = '/buyget/buyget-hero-banner-postpaid-addons.jsp',
  POSTPAID_MIGRATION_BANNER = '/portal/upgrade-to-postpaid.jsp',
  FAQ_URL = '/c/mobile/add-ons/hybrid/hybrid-addons.jsp',
  ADDON_CSS_URL='etisalat-headlibs/master.head.html',
  PREPAID_POSTER_URL = '',
  VISITOR_LINE_POSTER_URL = '',
  CONTROL_LINE_POSTER_URL = '',
  ROAMING_NEED_TO_KNOW='/c/mobile/plans/roaming/addons-index/master.html',
  ADDON_NOT_SEARCHED_URL='',
  E_LIFE_POSTER_URL = '',
  TV_POSTER_URL = '',
  CALLS_POSTER_URL = '',
  LOADER_COLOR = '#E00800',
  LOCAL_CURRENTCY = 'AED',
  RESET_FILTER = 'RESET',
  //SESSION
  SESSION_IDLE_TIME = 150,
  SESSION_IDLE_TIMEOUT = 5,
  SESSION_KEEP_ALIVE_TIME = 15,

  //BUNDLE SETTINGS

  NAVIGATION_STATE = '',
  NO = '0',
  IS_APPLY_DEFAULT_FILTERS = 1,

  //ADDON_CATEGOIRES
  MY_ADDONS = 'cat690015',
  POSTPAID = 'cat550027',
  PREPAID = 'cat550028',
  VISITOR_LINE = 'cat550023',
  CONTROL_LINE = 'cat550022',
  E_LIFE = 'cat550031',
  TV = 'cat550030',
  CALLS = 'cat550029',
  ADDTOBILL= 'cat1410020',//'cat1390015',
  HOME_BOUND = 'cat1040018',
  LOGIN_ROAMING = 'cat660025',
  POSTPAID_ROAMING = 'cat550044',
  PREPAID_ROAMING = 'cat550054',
  PREPAID_ROAMING_2 = 'cat550044',
  PREPAID_ROAMING_3 = 'cat940015',
  //ADDON_SUBCATEGORIES
  //DEVICE
  SMART_PHONE = 'cat550037',
  TABLETS = 'cat550038',

  //ACCESSORIES
  ACCESSORIES = 'cat550039',

  //POSTPAID
  FREEDOM = 'cat820016',
  NEW_POSTPAID = 'cat580020',
  PREMIUM_POSTPAID = 'cat580022',
  ETISALAT_SMART = 'cat600017',
  ETISALAT_EMIRATI = 'cat580021',
  FREEDOM_UNLIMITED = 'cat820015',

  SUB_VISITOR_LINE = 'cat550035',
  SUB_CONTROL_LINE = 'cat550036',

  //PREPAID
  SUB_PREPAID = 'cat550034',

  //OFFERS
  OFFERS = 'cat740023',

  //eLife
  INTENET_TV_TELEPHONE = 'cat550049',
  ELIFE_CATEGORY_NAME = 'INTENETTVTELEPHONE',

  //SMART_PAY_PLAN
  SMART_PAY_PLAN = '',
  ETISALAT_EBRIDGE_LITE = 'sku2090302',
  ETISALAT_EBRIDGE_PREIMUM = 'sku2090303',

  ERROR = 'Sorry, something went wrong. Please try again later.',
  ERROR_RTF_VAL_00015 = 'ERROR_RTF_VAL-00015',
  ERROR_VAL_00015 = 'VAL-00015',
  ECARE_ERROR_VAL_00015 = 'ecare.bridge-addon.err-addOrUpdateSubscription.rtf-failure-VAL-00015',
  PROFILE_IMAGE = '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',
  CALL_ICON = 'https://www.etisalat.ae/en/system/wst/assets/img/2021/bulk/add-ons/icon-data.svg',
  NO_RECORD_FOUND = '{"filters":[{"name":"Category","dimensionName":"parentCategory.displayName","dimensionInputType":"radio","dimensionValues":[],"refinementsCount":0},{"name":"Validity","dimensionName":"sku.validityType","dimensionInputType":"checkboxes","dimensionValues":[],"refinementsCount":0},{"dimensionName":"sku.isAutoRenewalFilter","dimensionInputType":"checkboxes","dimensionValues":[],"refinementsCount":0}],"products":[{"productId":"","productName":"","skus":[],"browsable":false,"planSkus":[],"allowOneTimePayment":false,"allowSmartPay":false}],"sortingItems":[],"recordCount":0,"lastRecordIndex":0,"currentCategory":"","success":true,"passAllowedIncludedIcons":"0","passAllowedDiscountedIcons":"0","passAllowedAdditionalNotes":"0","breadCrumbs":{"label":"","breadCrumbsAncestors":[{"label":"Add-ons","navigationState":"","categoryId":""}]},"enableCompare":false}',

  ERROR_VAL_00305 = 'ecare.bridge-addon.err-addOrUpdateSubscription.rtf-failure-VAL-00305',
  ERROR_VAL_00167 = 'ecare.bridge-addon.err-addOrUpdateSubscription.rtf-failure-VAL-00167',
  ERROR_CBCM_00002 = 'ecare.bridge-addon.err-addOrUpdateSubscription.rtf-failure-CBCM-00002',
  ERROR_VAL_00303 = 'ecare.bridge-addon.err-addOrUpdateSubscription.rtf-failure-VAL-00303',
  ERROR_IN_00002 = 'ecare.bridge-addon.err-addOrUpdateSubscription.rtf-failure-IN-00002',
  ERROR_VAL_00180 = 'ecare.bridge-addon.err-addOrUpdateSubscription.rtf-failure-VAL-00180',
  ERROR_VAL_00227 = 'ecare.bridge-addon.err-addOrUpdateSubscription.rtf-failure-VAL-00227',
  ERROR_VAL_00011 = 'ADDONS-BUY.RTF.ERRORCODE.VAL-00011',
  ERROR_VAL_00002 = 'ADDONS-BUY.RTF.ERRORCODE.IN-00002',
  ERROR_VAL_E222 = 'ADDONS-BUY.RTF.ERRORCODE.E222',
  VAL_00011 = 'VAL-00011',
  VAL_EAQTY = 'EAQTY',
  VAL_00061 = 'VAL-00061',
  VAL_00133 = 'VAL-00133',
  VAL_00013 = 'VAL-00013',
   VAL_E222 = 'E222',
  ADOBE_BACKUP_SCRIPT = 'https://assets.adobedtm.com/0d04dd99f59e/07c17e71a414/launch-c0f5c0b15947-development.min.js',
  LIVE_PROMO_BANNER_NWT='/c/mobile/plans/freedom-live-hybrid-sections/freedom-live-intro.jsp ',
  LIVE_CONTEXT_NAV_NWT='/c/mobile/plans/freedom-live-hybrid-sections/how-to-claim.jsp',
  LIVE_EXISTING_ETISALAT_PLAN='/c/mobile/plans/freedom-live-hybrid.jsp',
  LIVE_BANNER='/c/mobile/plans/freedom-live-hybrid-sections/banner.jsp ',
  STATIC_PASSES = "passPrd-01",
  CARAMEL_CATEGORY = "catfreedom-live-plans",
  KIDS_ADDONS = "KIDS_ADDON",
  ERROR_RTF_VAL_00080 = 'ERROR_RTF_VAL-00080',
  ERROR_VAL_00080 = 'ADDONS-BUY.RTF.ERRORCODE.VAL-00080',
  ERROR_VAL_00019 = 'VAL-00019',
  PLANT_A_TREE= 'plantATree',
  CMS_CONTENT_URL = '/c/plan-a-tree/master.body.html'
}
